export default class ReportGroupService {
  sortBy(arr, evalFuncs, compareFunctions) {
    return arr.toSorted((a, b) => {
      return compareFunctions.reduce((result, f, idx) => {
        return result || f(evalFuncs[idx](a), evalFuncs[idx](b));
      }, 0);
    });
  }

  groupBy(arr, evaluationFunction, aggregations = []) {
    const grouped = new Map();
    for (const obj of arr) {
      const value = evaluationFunction(obj);
      if (!grouped.has(value)) {
        const subtotals = aggregations.reduce((acc, k) => ({ ...acc, [k]: { display: 0 } }), {});
        grouped.set(value, { values: [], subtotals });
      }
      grouped.get(value).values.push(obj);
    }
    return grouped;
  }

  outputGroups(groups, property) {
    let output = [];
    let totals = {[property]: { display: `Total`}, _class: "report-totals"};
    let groupId = 1;
    for (const [key, group] of groups) {
      const { values, subtotals } = group;
      const summaryDisplay = `<span class="summary-title">${key}</span><span class="summary-count">(${values.length})</span>`;
      const summary = { [property]: { display: summaryDisplay }, _class: `report-summary report-group-${ groupId }` };
      const valuesGroup = values.map(v => ({ ...v, _class: `report-item report-group-${ groupId }`, _groupId: groupId }));
      subtotals._class = `report-subtotals report-group-${ groupId }`;
      output = output.concat([summary, ...valuesGroup, subtotals]);
      groupId++;
    }

    return [...output, totals];
  }

  _lower(v) {
    return `${v}`.toLowerCase();
  }

  compare() {
    const numericAsc = (a, b) => a - b;
    const dateAsc = (a, b) => new Date(a) - new Date(b);
    const textAsc = (a, b) => {
      const lA = this._lower(a), lB = this._lower(b);
      if (lA > lB) return 1;
      if (lA < lB) return -1;
      return 0;
    }

    return {
      numeric: {
        ASC: numericAsc,
        DESC: (a, b) => { return numericAsc(a, b) * -1 },
      },
      text: {
        ASC: textAsc,
        DESC: (a, b) => { return textAsc(a, b) * -1 },
      },
      date: {
        ASC: dateAsc,
        DESC: (a, b) => { return dateAsc(a, b) * -1 }
      }
    }
  }

  evaluate() {
    return {
      numeric: (obj, prop) => { return obj[prop]?.value || 0 },
      text: (obj, prop) => { return obj[prop]?.value || "" },
      date: (obj, prop) => { return obj[prop]?.value || new Date() }
    }
  }
}
